// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle

/**
 * @name listItem_node
 */
export const listItem = {
  content: '(paragraph | mediaSingle | codeBlock) (paragraph | bulletList | orderedList | mediaSingle | codeBlock)*',
  marks: 'unsupportedMark unsupportedNodeAttribute',
  defining: true,
  selectable: false,
  parseDOM: [{
    tag: 'li'
  }],

  toDOM() {
    return ['li', 0];
  }

};